import { ChevronRightOutlined, KeyboardArrowDown } from "@mui/icons-material";
import { isString } from "lodash";
import Flx from "../../layout/Flx";

const CellRendererAccordianLabel = ({
  params,
  value,
  active,
  content,
  endContent,
}) => {
  const text = value || params?.valueFormatted || params?.value;

  if (!isString(text)) {
    return null;
  }

  const displayed_content = content ? (
    content
  ) : (
    <>
      <span>{text}</span>
      {endContent}
    </>
  );
  return (
    <Flx ac gap={1}>
      {active ? (
        <KeyboardArrowDown className="thin" />
      ) : (
        <ChevronRightOutlined className="thin" />
      )}
      {displayed_content}
    </Flx>
  );
};

export default CellRendererAccordianLabel;
